import React, { useState, useEffect, useMemo } from 'react';
import { NavLink } from "react-router-dom";
import { Bar, Line, Doughnut, Pie, Radar, Scatter, Bubble } from 'react-chartjs-2';
import * as XLSX from 'xlsx';
import axios from 'axios';
import Select from 'react-select';
import './Common.css';

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css'; // Import the CSS file

import ReactECharts from 'echarts-for-react';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import { Chrono } from 'react-chrono';

import { ReactComponent as RightIcon } from '../icons/home/right.svg';
import { ReactComponent as LeftIcon } from '../icons/home/left.svg';
import { ReactComponent as WidgetsBigIcon } from '../icons/widgetsBig.svg';
import { ReactComponent as DashboardsBigIcon } from '../icons/dashboardBig.svg';
import { ReactComponent as DadosBigIcon } from '../icons/databaseBig.svg';
import { ReactComponent as ProjetosBigIcon } from '../icons/folderBig.svg';
import { ReactComponent as HappyIcon } from '../icons/happy.svg';
import { ReactComponent as SadIcon } from '../icons/sad.svg';
  import { ReactComponent as NumberIcon } from '../icons/number_icon.svg';
import { ReactComponent as TrashIcon } from '../icons/home/trash.svg';
import { ReactComponent as PenIcon } from '../icons/home/pen.svg';
import { ReactComponent as ExportIcon } from '../icons/home/export.svg';
import { ReactComponent as CopyIcon } from '../icons/home/copy.svg';
import { ReactComponent as EyeIcon } from '../icons/home/eye.svg';
import { ReactComponent as ShareIcon } from '../icons/home/share.svg';
import { ReactComponent as SaveIcon } from '../icons/home/save.svg';
import { ReactComponent as timelineIcon } from '../icons/timeline.svg';
import { ReactComponent as timelineHIcon } from '../icons/timelineHorizontal.svg';
import { ReactComponent as spiderIcon } from '../icons/spider.svg';

import { ReactComponent as Group16 } from '../icons/Group16.svg';
import { ReactComponent as Group17 } from '../icons/Group17.svg';
import { ReactComponent as Group18 } from '../icons/Group18.svg';
import { ReactComponent as Group20 } from '../icons/Group20.svg';
import { ReactComponent as Group21 } from '../icons/Group21.svg';
import { ReactComponent as Group22 } from '../icons/Group22.svg';
import { ReactComponent as Group23 } from '../icons/Group23.svg';
import { ReactComponent as Group26 } from '../icons/Group26.svg';
import { ReactComponent as Group27 } from '../icons/Group27.svg';
import { ReactComponent as Group28 } from '../icons/Group28.svg';
import { ReactComponent as Group32 } from '../icons/Group32.svg';
import { ReactComponent as Group33 } from '../icons/Group33.svg';
import { ReactComponent as Group40 } from '../icons/Group40.svg';
import { ReactComponent as Group41 } from '../icons/Group41.svg';
import { ReactComponent as Group43 } from '../icons/Group43.svg';
import { ReactComponent as Group44 } from '../icons/Group44.svg';
import { ReactComponent as Group56 } from '../icons/Group56.svg';
import { ReactComponent as Group17x } from '../icons/Group17x.svg';
import { ReactComponent as Group20x } from '../icons/Group20x.svg';
import { ReactComponent as Group21x } from '../icons/Group21x.svg';
import { ReactComponent as Group22x } from '../icons/Group22x.svg';
import { ReactComponent as Group23x } from '../icons/Group23x.svg';
import { ReactComponent as Group26x } from '../icons/Group26x.svg';
import { ReactComponent as Group27x } from '../icons/Group27x.svg';
import { ReactComponent as spiderIconx } from '../icons/spiderx.svg';
import { ReactComponent as Group32x } from '../icons/Group32x.svg';
import { ReactComponent as Group33x } from '../icons/Group33x.svg';
import { ReactComponent as timelineIconx } from '../icons/timelinex.svg';
import { ReactComponent as timelineHIconx } from '../icons/timelineHorizontalx.svg';
import { ReactComponent as Group41x } from '../icons/Group41x.svg';
import { ReactComponent as Group40x } from '../icons/Group40x.svg';
import { ReactComponent as Group28x } from '../icons/Group28x.svg';
import { ReactComponent as Group44x } from '../icons/Group44x.svg';
import { ReactComponent as Group43x } from '../icons/Group43x.svg';

import { ReactComponent as SumatorioIcon } from '../icons/SumatorioIcon.svg';
import { ReactComponent as SumatorioIconx } from '../icons/SumatorioIconx.svg';
import { ReactComponent as AverageIcon } from '../icons/AverageIcon.svg';
import { ReactComponent as AverageIconx } from '../icons/AverageIconx.svg';
import { ReactComponent as MedianIcon } from '../icons/MedianIcon.svg';
import { ReactComponent as MedianIconx } from '../icons/MedianIconx.svg';

import { ReactComponent as dash1 } from '../icons/dash1.svg';
import { ReactComponent as dash2 } from '../icons/dash2.svg';
import { ReactComponent as dash3 } from '../icons/dash3.svg';
import { ReactComponent as dash4 } from '../icons/dash4.svg';


//export const API_BASE_URL = 'http://localhost:3046';
//export const API_BASE_URL = 'http://api.dashboards.prochild.local:3046';
export const API_BASE_URL = 'https://api.dashboards.prochildcolab.pt';

const TableComponent = ({ data }) => {
  const styles = {
    container: {
      height: '100%',         // fill parent
      overflow: 'auto',       // vertical + horizontal scroll
    },
    table: {
      width: '100%',
      height: '100%',         // table fills container
      borderCollapse: 'separate',
      borderSpacing: '3px',
      tableLayout: 'fixed',   // evenly sized columns
    },
    th: {
      padding: '14px 16px',
      textAlign: 'center',
      backgroundColor: '#243884',
      color: '#FFF',
      fontFamily: 'Roboto',
      fontSize: '15px',
      fontWeight: 600,
      lineHeight: '19px',
      textTransform: 'uppercase',
      position: 'sticky',
      top: 0,
      zIndex: 2,              // keep header above rows
    },
    td: {
      padding: '12px 16px',
      textAlign: 'center',
      borderBottom: '1px solid #e0e0e0',
      fontFamily: 'Roboto',
      fontSize: '15px',
      fontWeight: 400,
      lineHeight: '19px',
      color: '#233C7E',
    },
    labelCell: {
      textAlign: 'center',
      fontWeight: 600,
      padding: '12px 16px',
      color: '#FFF',
      fontFamily: 'Roboto',
      fontSize: '15px',
      lineHeight: '19px',
      backgroundColor: '#41BBC9',
      borderRight: '1px solid #e0e0e0',
      position: 'sticky',
      left: 0,
      zIndex: 1,              // keep label above row background
    },
    trOdd: { backgroundColor: 'rgba(35, 60, 126, 0.07)' },
    trEven: { backgroundColor: 'rgba(35, 60, 126, 0.07)' },
  };

  return (
    <div style={styles.container}>
      <table style={styles.table}>
        <thead>
          <tr>
            <th
              style={{
                ...styles.th,
                backgroundColor: 'transparent',
                border: 'none',
                padding: 0,
              }}
            />
            {data.labels.map((label, index) => (
              <th
                key={index}
                style={{
                  ...styles.th,
                  borderTopLeftRadius: index === 0 ? '8px' : '0',
                  borderTopRightRadius: index === data.labels.length - 1 ? '8px' : '0',
                }}
              >
                {label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.datasets.map((dataset, index) => {
            const isFirstRow = index === 0;
            const isLastRow = index === data.datasets.length - 1;

            return (
              <tr
                key={index}
                style={index % 2 === 0 ? styles.trEven : styles.trOdd}
              >
                <td
                  style={{
                    ...styles.labelCell,
                    borderTopLeftRadius: isFirstRow ? '8px' : '0',
                    borderBottomLeftRadius: isLastRow ? '8px' : '0',
                  }}
                >
                  {dataset.label}
                </td>
                {dataset.data.map((value, valueIndex) => (
                  <td key={valueIndex} style={styles.td}>
                    {parseFloat(value).toFixed(2)}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const TreemapComponent = ({ data }) => {
  // Transform data into the format required by ECharts
  const transformedData = data.datasets.map((dataset, datasetIndex) => {
    return {
      name: dataset.label,
      children: data.labels.map((label, labelIndex) => {
        const color = getDeterministicColor(undefined, labelIndex); // No seed, color per label
        return {
          name: label || `No Label ${labelIndex}`,
          value: parseFloat(dataset.data[labelIndex]) || 0,
          itemStyle: {
            color: color,
            borderColor: '#fff',
            borderWidth: 1
          }
        };
      }).filter(item => item.value > 0) // Filter out zero values
    };
  });

  const option = {
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        return `${params.name}<br/>Valor: ${params.value}`;
      }
    },
    series: [
      {
        type: 'treemap',
        data: transformedData,
        label: {
          show: true,
          formatter: '{b}'
        },
        itemStyle: {
          borderColor: '#fff'
        }
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: 'calc(100% - 10px)', width: '100%' }} />;
};


// Normalize strings: case-insensitive + accent-safe
const normalizeRegion = (value = "") =>
  value
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const GEOJSON_SOURCES = [
  {
    path: "/NUTS_1.json",
    nameProps: ["NUTS_ID"],
  },
  {
    path: "/nutsII_4326.json",
    nameProps: ["NUTE_NAME"],
  },
  {
    path: "/NUTS_3.json",
    nameProps: ["NUTS_ID"],
  },
  {
    path: "/countries.json",
    nameProps: ["ADMIN"],
  },
  {
    path: "/continente.json",
    nameProps: ["CONTINENT"],
  },
{
    path: "/distrito.json",
    nameProps: ["NAME_1"],
  },
{
    path: "/municipio.json",
    nameProps: ["NAME_2"],
  },
{
    path: "/freguesia.json",
    nameProps: ["NAME_3"],
  },
];

const geoJsonCache = new Map();

const fetchGeoJSONCached = async path => {
  if (geoJsonCache.has(path)) {
    return geoJsonCache.get(path);
  }

  const res = await fetch(path);
  const json = await res.json();

  geoJsonCache.set(path, json);
  return json;
};

const getFeatureName = (feature, nameProps) => {
  for (const prop of nameProps) {
    if (feature.properties?.[prop]) {
      return normalizeRegion(feature.properties[prop]);
    }
  }
  return null;
};

const GeoMapComponent = ({ data }) => {
  const [geoJsonData, setGeoJsonData] = useState(null);
  const [activeNameProps, setActiveNameProps] = useState([]);

  const dataset = data?.datasets?.[0] || { data: [], label: "" };
  const values = dataset.data || [];
  const geo = data?.labels || [];

  /* -----------------------------------------
     Region → Value Map
  ----------------------------------------- */
  const valueMap = useMemo(() => {
    return geo.reduce((acc, name, index) => {
      acc[normalizeRegion(name)] = values[index] ?? 0;
      return acc;
    }, {});
  }, [geo, values]);

  /* -----------------------------------------
     Frequency Map
  ----------------------------------------- */
  const frequencyMap = useMemo(() => {
    return geo.reduce((acc, name) => {
      const key = normalizeRegion(name);
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});
  }, [geo]);

  const maxFrequency = Math.max(...Object.values(frequencyMap), 1);

  /* -----------------------------------------
     Auto-detect best GeoJSON (CACHED)
  ----------------------------------------- */
  useEffect(() => {
    if (!geo.length) return;

    const detectBestGeoJSON = async () => {
      const normalizedGeo = geo.map(normalizeRegion);

      let bestMatch = {
        score: 0,
        data: null,
        nameProps: null,
      };

      for (const source of GEOJSON_SOURCES) {
        try {
          const json = await fetchGeoJSONCached(source.path);

          const featureNames = json.features
            .map(f => getFeatureName(f, source.nameProps))
            .filter(Boolean);

          const score = normalizedGeo.filter(name =>
            featureNames.includes(name)
          ).length;

          if (
            score > bestMatch.score ||
            (score === bestMatch.score &&
              json.features.length >
                (bestMatch.data?.features.length || 0))
          ) {
            bestMatch = {
              score,
              data: json,
              nameProps: source.nameProps,
            };
          }
        } catch (err) {
          console.error(`Failed loading ${source.path}`, err);
        }
      }

      if (bestMatch.data) {
        setGeoJsonData(bestMatch.data);
        setActiveNameProps(bestMatch.nameProps);
      }
    };

    detectBestGeoJSON();
  }, [geo]);

  /* -----------------------------------------
     Stable Region → Color Map
  ----------------------------------------- */
  const regionColorMap = useMemo(() => {
  const uniqueRegions = [...new Set(geo.map(normalizeRegion))];

  return uniqueRegions.reduce((acc, region, index) => {
    const color = getDeterministicColor(region);
    acc[region] = color;
    return acc;
  }, {});
}, [geo]);


  /* -----------------------------------------
     GeoJSON Styling
  ----------------------------------------- */
  const styleFeature = feature => {
    const rawName = activeNameProps
      .map(p => feature.properties?.[p])
      .find(Boolean);

    const name = normalizeRegion(rawName);
    const count = frequencyMap[name] || 0;

    return {
      fillColor: regionColorMap[name] || "#CCCCCC",
      weight: count > 0 ? 2 : 0,
      color: count > 0 ? "white" : "transparent",
      dashArray: count > 0 ? "3" : "0",
      fillOpacity:
        count > 0 ? 0.3 + (count / maxFrequency) * 0.4 : 0,
    };
  };

  /* -----------------------------------------
     Click Popup
  ----------------------------------------- */
  const onEachFeature = (feature, layer) => {
    const rawName = activeNameProps
      .map(p => feature.properties?.[p])
      .find(Boolean);

    const name = normalizeRegion(rawName);
    const value = valueMap[name] ?? "No data";

    layer.on("click", () => {
      layer
        .bindPopup(
          `<strong>${rawName}</strong><br/>
           ${dataset.label}: ${value}`
        )
        .openPopup();
    });
  };

  /* -----------------------------------------
     Render
  ----------------------------------------- */
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <MapContainer
        attributionControl={false}
        center={[39.6, -8.0]}
        zoom={6}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />

        {geoJsonData && (
          <GeoJSON
            data={geoJsonData}
            style={styleFeature}
            onEachFeature={onEachFeature}
          />
        )}
      </MapContainer>
    </div>
  );
};



const getAllValues = (data) => {
  if (!data || !data.datasets) return [];
  return data.datasets.flatMap((dataset) =>
    dataset.data.map((value) => parseFloat(value) || 0)
  );
};

// Reusable component for any statistic
const StatisticCard = ({ title, value }) => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    userSelect: 'none',
    gap: '0.5rem',
  };

  const titleStyle = {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    color: '#6b7280',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  };

  const bigNumberStyle = {
    color: '#233C7E',
    fontFamily: 'Roboto',
    fontSize: '38px',
    fontWeight: 600,
    margin: 0,
  };

  return (
    <div style={containerStyle}>
      <div style={titleStyle}>{title}</div>
      <p style={bigNumberStyle}>{value}</p>
    </div>
  );
};

export const Sumatorio = ({ data }) => {
  const values = getAllValues(data);
  const sum = values.reduce((acc, value) => acc + value, 0).toFixed(2);
  return <StatisticCard title="Soma" value={sum} />;
};

export const Average = ({ data }) => {
  const values = getAllValues(data);
  const average =
    values.length === 0
      ? '0.00'
      : (values.reduce((acc, value) => acc + value, 0) / values.length).toFixed(2);
  return <StatisticCard title="Média" value={average} />;
};

export const Median = ({ data }) => {
  const values = getAllValues(data).sort((a, b) => a - b);
  let median = '0.00';
  const len = values.length;

  if (len > 0) {
    const middle = Math.floor(len / 2);
    median =
      len % 2 === 0
        ? ((values[middle - 1] + values[middle]) / 2).toFixed(2)
        : values[middle].toFixed(2);
  }

  return <StatisticCard title="Mediana" value={median} />;
};

const TimelineComponent = ({ data, mode }) => {
  const titles = data.labels || [];
  const descriptionDataset = data.datasets[0] || { data: [] };
  const dateDataset = data.datasets[1] || { data: [] };

  let descriptions = descriptionDataset.data;
  let dates = dateDataset.data;

  const parseDate = (dateValue) => {
    if (dateValue === null || dateValue === undefined) return null;

    const dateString = String(dateValue).trim();

    const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (isoDateRegex.test(dateString)) {
      return new Date(dateString);
    }

    const [day, month, year] = dateString.split('/');
    if (day && month && year) {
      const parsedDate = new Date(`${year}-${month}-${day}`);
      if (isNaN(parsedDate)) return null;
      return parsedDate;
    }

    return null;
  };

  const isFirstDatasetDates = descriptions.every((item) => parseDate(item) !== null);
  if (isFirstDatasetDates) {
    descriptions = dateDataset.data;
    dates = descriptionDataset.data;
  }

  const events = titles.map((title, index) => ({
    title,
    description: descriptions[index] || 'Not available',
    date: parseDate(dates[index]),
  }));

  const hasInvalidDates = events.some((event) => event.date === null);

  // Inline styles
  const placeholderStyles = {
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      padding: '20px',
    },
    card: {
      width: '100%',
      maxWidth: '520px',
      border: '2px solid #233A80',
      background: '#ffffff',
      borderRadius: '10px',
      padding: '18px',
      display: 'flex',
      gap: '16px',
      alignItems: 'center',
      boxShadow: '0 8px 20px rgba(35, 58, 128, 0.12)',
    },
    icon: {
      width: '48px',
      height: '48px',
      borderRadius: '12px',
      background: '#f7f7ff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: '2px solid #233A80',
    },
    title: {
      margin: '0 0 6px 0',
      fontFamily: 'Roboto Flex',
      fontWeight: 700,
      fontSize: '16px',
      color: '#233A80',
    },
    text: {
      margin: 0,
      fontFamily: 'Roboto Flex',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: 1.4,
      color: '#394b90',
    },
    strong: {
      color: '#233A80',
    },
  };

  if (hasInvalidDates) {
  return (
    <div style={placeholderStyles.wrapper}>
      <div style={placeholderStyles.card}>

        {/* icon without rectangle */}
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
            stroke="#233A80"
            strokeWidth="2"
          />
          <path
            d="M12 7v6"
            stroke="#233A80"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M12 16h.01"
            stroke="#233A80"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>

        <div>
          <h3 style={placeholderStyles.title}>Gráfico não compatível</h3>
          <p style={placeholderStyles.text}>
            Os dados não estão no formato correto para o timeline.
            Use uma coluna de datas em <span style={placeholderStyles.strong}>YYYY-MM-DD</span> ou{' '}
            <span style={placeholderStyles.strong}>DD/MM/YYYY</span>.
          </p>
        </div>

      </div>
    </div>
  );
}


  const sortedEvents = events.sort((a, b) => a.date - b.date);

  const timelineItems = sortedEvents.map((event) => ({
    title: event.title,
    cardTitle: event.title,
    cardSubtitle: event.date.toLocaleDateString(),
    cardDetailedText: event.description,
    date: event.date,
  }));

  return (
    <div style={{ maxHeight: 'calc(100% - 30px)', width: '100%', height: '100%', margin: 'auto' }}>
      <Chrono
        items={timelineItems}
        mode={mode}
        slideShow={true}
        buttonTexts={{
          first: 'Saltar para o Primeiro',
          last: 'Saltar para o Último',
          next: 'Próximo',
          previous: 'Anterior',
          play: 'Reproduzir Slideshow'
        }}
        theme={{
          primary: '#F7BE04',
          secondary: '#43BBC9',
          titleColor: '#43BBC9',
          titleColorActive: 'white',
          cardBgColor: 'white',
          cardTitleColor: '#43BBC9',
        }}
        enableLayoutSwitch={false}
        enableQuickJump={false}
        disableToolbar={false}
        cardHeight={'100'}
        itemWidth={'150'}
      />
    </div>
  );
};



const Timeline = (props) => <TimelineComponent {...props} mode="VERTICAL" />;
const HTimeline = (props) => <TimelineComponent {...props} mode="HORIZONTAL" />;

export const WidgetPlaceholder = ({ data, id, paletteWidgets, onSelectWidget }) => {

  const styles = {
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
      backgroundColor: '#F8F9FB',
      //border: '2px dashed #D6D9E0',
      //borderRadius: '8px',
      boxSizing: 'border-box',
      gap: '12px',
      padding: '16px',
    },
    icon: {
    opacity: 0.8,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transform: 'scale(2)',
  },
    text: {
      color: 'rgba(35, 58, 128, 0.49)',
      fontFamily: 'Roboto',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      textAlign: 'center',
      userSelect: 'none',
    },
  dropdown: {
  textAlign: 'center',      // ✅ center selected text
  textAlignLast: 'center',  // ✅ center text in dropdown field (important for select)
  marginTop: '8px',
  minWidth: '160px',
  height: '36px',
  padding: '6px 12px',
  borderRadius: '8px',
  border: '1px solid #E1E4ED',
  backgroundColor: '#FFFFFF',
  color: '#233C7E',
  fontFamily: 'Roboto, sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  cursor: 'pointer',
  outline: 'none',
  boxShadow: '0 1px 2px rgba(16, 24, 40, 0.05)',
  appearance: 'none', // cleaner modern look
}


  };

  const iconWrapperStyle = {
    ...styles.icon,
    color: '#B6BDD6',
  };

  const renderIcon = () => {
    switch (data) {
      case 'line':
        return <span style={iconWrapperStyle} className="widget-icon"><Group32 /></span>;
      case 'bar':
        return <span style={iconWrapperStyle} className="widget-icon"><Group22 /></span>;
      case 'table':
        return <span style={iconWrapperStyle} className="widget-icon"><Group43 /></span>;
      case 'pie':
        return <span style={iconWrapperStyle} className="widget-icon"><Group26 /></span>;
      default:
        return <span style={iconWrapperStyle} className="widget-icon"><Group32 /></span>;
    }
  };

  return (
    <div style={styles.wrapper}>
      {renderIcon()}
      <span style={styles.text}>Insira um Widget aqui</span>

      {/* Dropdown list of available widgets */}
      <select
        style={styles.dropdown}
        onChange={(e) => onSelectWidget(e.target.value, id)}
        defaultValue=""
      >
        <option value="" disabled hidden>Substituir Widget</option>
        {Object.entries(paletteWidgets || {}).map(([widgetId, widget]) => (
          <option key={widgetId} value={widgetId}>
            {widget.name || `Widget ${widgetId}`}
          </option>
        ))}
      </select>
    </div>
  );
};







const Titulo = ({ data, id }) => {
  const [title, setTitle] = useState(data);

  const styles = {
    titleWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      margin: '0 auto',
      boxSizing: 'border-box',
      paddingTop: '6px' // small safety offset
    },
    titleEditable: {
      color: '#233C7E',
      fontFamily: 'Roboto',
      fontSize: '30px',
      fontWeight: 700,
      lineHeight: '1.3',          // 🔑 must be numeric
      background: 'transparent',
      width: '100%',
      textAlign: 'center',
      padding: '10px',
      boxSizing: 'border-box',
      outline: 'none',
      border: 'none',
      wordBreak: 'break-word'
    }
  };

  const handleBlur = async (e) => {
    const newValue = e.target.innerText;
    if (newValue !== title) {
      setTitle(newValue);

      const token = localStorage.getItem('token');
      await axios.put(
        `${API_BASE_URL}/widgets/${id}/conteudo`,
        { conteudo: newValue },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    }
  };

  return (
    <div style={styles.titleWrapper}>
      <div
        contentEditable
        suppressContentEditableWarning
        style={styles.titleEditable}
        onBlur={handleBlur}
      >
        {title}
      </div>
    </div>
  );
};


const Subtitulo = ({ data, id }) => {
  const [subtitle, setSubtitle] = useState(data);

  const styles = {
    subtitleWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      margin: '0 auto',
      boxSizing: 'border-box',
      paddingTop: '4px',
    },
    subtitleEditable: {
      color: '#233C7E',
      fontFamily: 'Roboto',
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: '1.35',
      background: 'transparent',
      width: '100%',
      textAlign: 'center',
      padding: '8px',
      boxSizing: 'border-box',
      outline: 'none',
      border: 'none',
      wordBreak: 'break-word',
    },
  };

  const handleBlur = async (e) => {
    const newValue = e.target.innerText;
    if (newValue !== subtitle) {
      setSubtitle(newValue);

      const token = localStorage.getItem('token');
      await axios.put(
        `${API_BASE_URL}/widgets/${id}/conteudo`,
        { conteudo: newValue },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    }
  };

  return (
    <div style={styles.subtitleWrapper}>
      <div
        contentEditable
        suppressContentEditableWarning
        style={styles.subtitleEditable}
        onBlur={handleBlur}
      >
        {subtitle}
      </div>
    </div>
  );
};


const Paragrafo = ({ data, id }) => {
  const [paragraph, setParagraph] = useState(data);

  const styles = {
    paragraphWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      margin: '0 auto',
      boxSizing: 'border-box',
      padding: '10px',
    },
    paragraphEditable: {
      display: 'flex',                 // 🔑 key
      alignItems: 'center',             // 🔑 vertical center
      justifyContent: 'center',         // 🔑 horizontal center
      color: '#233C7E',
      fontFamily: 'Roboto',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '1.5',
      background: 'transparent',
      width: '100%',
      height: '100%',                   // 🔑 fill container
      textAlign: 'center',
      padding: '10px',
      boxSizing: 'border-box',
      outline: 'none',
      border: 'none',
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
    },
  };

  const handleBlur = async (e) => {
    const newValue = e.target.innerText;
    if (newValue !== paragraph) {
      setParagraph(newValue);

      const token = localStorage.getItem('token');
      await axios.put(
        `${API_BASE_URL}/widgets/${id}/conteudo`,
        { conteudo: newValue },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    }
  };

  return (
    <div style={styles.paragraphWrapper}>
      <div
        contentEditable
        suppressContentEditableWarning
        style={styles.paragraphEditable}
        onBlur={handleBlur}
      >
        {paragraph}
      </div>
    </div>
  );
};



const Imagem = ({ data, id }) => {
  const [image, setImage] = useState(data); // State to manage the current image

  const styles = {
    mainWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',  // Ensure mainWrapper takes up full width of the parent
      height: '100%', // Ensure mainWrapper takes up full height of the parent
      maxHeight: '100%', // Maintain height constraint relative to parent
      maxWidth: '100%', // Maintain width constraint relative to parent
      padding: '3px',
      //background: '#f8f8f8',     // Light background color for contrast
      boxSizing: 'border-box', // Ensure padding and border are considered in width/height
    },
    imageWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      overflow: 'hidden', // Ensure the image does not overflow the wrapper
      boxSizing: 'border-box', // Include padding and border in dimensions
      cursor: 'pointer', // Cursor indicates it's clickable
    },
    image: {
      maxWidth: '100%', // Ensure the image fits within the wrapper
      maxHeight: '100%', // Ensure the image doesn't exceed the wrapper's height
    },
    hiddenFileInput: {
      display: 'none', // Hide the file input
    },
  };

  // Function to handle image change (file selected)
  const handleFileChange = async (e) => {
    const file = e.target.files[0]; // Get the first file

    if (file) {
      await uploadImage(file);
    }
  };

  // Function to upload the image to the server
  const uploadImage = async (file) => {
    try {
      // Get the token from localStorage
      const token = localStorage.getItem('token');

      // Create a FormData object to hold the file data
      const formData = new FormData();
      formData.append('image', file); // Append the selected file

      // Make a POST request to upload the image
      const response = await axios.post(
        `${API_BASE_URL}/widgets/${id}/upload-image`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`, // Include the Authorization header
          },
        }
      );

      // Update the image state with the new image path after a successful upload
      setImage(response.data.imagePath); // Assuming the API returns the new image path
      alert("Imagem atualizada!");
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("Erro ao atualizar a imagem.");
    }
  };

  // Function to trigger the hidden file input when the image is clicked
  const handleImageClick = () => {
    document.getElementById(`fileInput-${id}`).click(); // Trigger the hidden file input
  };

  return (
    <div style={styles.mainWrapper}>
      {/* Image display area */}
      <div style={styles.imageWrapper} onClick={handleImageClick}>
        <img src={`${API_BASE_URL}/${image}`} alt="" style={styles.image} />
      </div>

      {/* Hidden file input */}
      <input
        type="file"
        id={`fileInput-${id}`} // Unique id based on the widget Id
        style={styles.hiddenFileInput}
        accept="image/*"
        onChange={handleFileChange} // Trigger image upload when a file is selected
      />
    </div>
  );
};


const dispersao_bolhas_Options = {
  maintainAspectRatio: false,
  scales: {
    x: {
      type: 'category', // Use category type for x-axis
    },
    y: {
      beginAtZero: true, // Ensure y-axis starts at zero
    },
  },
  layout: {
    padding: {
      bottom: 0,
    },
  },
};

export const chartGroups = [
  null,

  // ─────────────────────────────────────
  // Group 1 — BIG NUMBER / KPI
  // ─────────────────────────────────────
  {
    25: { component: Sumatorio, label: "Soma", icon: SumatorioIcon, iconSelected: SumatorioIconx },
    125: { component: Average, label: "Média", icon: AverageIcon, iconSelected: AverageIconx },
    126: { component: Median, label: "Mediana", icon: MedianIcon, iconSelected: MedianIconx },
  },

  // ─────────────────────────────────────
  // Group 2 — COMPARISON (BARS)
  // ─────────────────────────────────────
  {
    12: {
      component: Bar,
      label: "Barras empilhadas (vertical)",
      icon: Group20,
      iconSelected: Group20x,
      options: {
        maintainAspectRatio: false,
        layout: { padding: { bottom: 0 } },
        indexAxis: "x",
        scales: { x: { stacked: true }, y: { stacked: true } },
      },
    },
    13: {
      component: Bar,
      label: "Barras empilhadas (horizontal)",
      icon: Group21,
      iconSelected: Group21x,
      options: {
        maintainAspectRatio: false,
        layout: { padding: { right: 0, bottom: 0 } },
        indexAxis: "y",
        scales: { x: { stacked: true }, y: { stacked: true } },
      },
    },
    14: {
      component: Bar,
      label: "Barras verticais",
      icon: Group22,
      iconSelected: Group22x,
      options: {
        maintainAspectRatio: false,
        layout: { padding: { bottom: 0 } },
        indexAxis: "x",
        scales: { x: { stacked: false }, y: { stacked: false } },
      },
    },
    15: {
      component: Bar,
      label: "Barras horizontais",
      icon: Group23,
      iconSelected: Group23x,
      options: {
        maintainAspectRatio: false,
        layout: { padding: { right: 0, bottom: 0 } },
        indexAxis: "y",
        scales: { x: { stacked: false }, y: { stacked: false } },
      },
    },
  },

  // ─────────────────────────────────────
  // Group 3 — PROPORTIONS
  // ─────────────────────────────────────
  {
    3: {
      component: Pie,
      label: "Pizza",
      icon: Group26,
      iconSelected: Group26x,
      options: { maintainAspectRatio: false, layout: { padding: { bottom: 0 } } },
    },
    4: {
      component: Doughnut,
      label: "Rosca",
      icon: Group27,
      iconSelected: Group27x,
      options: { maintainAspectRatio: false, layout: { padding: { bottom: 0 } } },
    },
    19: {
      component: Radar,
      label: "Radar",
      icon: spiderIcon,
      iconSelected: spiderIconx,
      options: { maintainAspectRatio: false, layout: { padding: { bottom: 0 } } },
    },
  },

  // ─────────────────────────────────────
  // Group 4 — TIME EVOLUTION
  // ─────────────────────────────────────
  {
    1: {
  component: Line,
  label: "Linha",
  icon: Group32,
  iconSelected: Group32x,
  options: {
    maintainAspectRatio: false,
    layout: { padding: { right: 0, bottom: 0 } },
    elements: {
      line: {
        tension: 0.4,
        borderWidth: 2,
        fill: false,
      },
    },
  },
},

    2: {
      component: Line,
      label: "Área",
      icon: Group33,
      iconSelected: Group33x,
      options: {
        maintainAspectRatio: false,
        layout: { padding: { right: 0, bottom: 0 } },
        scales: { x: { stacked: false, beginAtZero: true }, y: { stacked: true, beginAtZero: true } },
        elements: { line: { tension: 0.4, borderWidth: 2, fill: true } },
      },
    },
    26: { component: Timeline, label: "Timeline vertical", icon: timelineIcon, iconSelected: timelineIconx },
    200: { component: HTimeline, label: "Timeline horizontal", icon: timelineHIcon, iconSelected: timelineHIconx  },
  },

  // ─────────────────────────────────────
  // Group 5 — CORRELATION & DISPERSION
  // ─────────────────────────────────────
  {
    17: { component: Scatter, label: "Dispersão", icon: Group41, iconSelected: Group41x, options: dispersao_bolhas_Options },
    18: { component: Bubble, label: "Bolhas", icon: Group40, iconSelected: Group40x, options: dispersao_bolhas_Options },
  },

  // ─────────────────────────────────────
  // Group 6 — HIERARCHY & GEO
  // ─────────────────────────────────────
  {
    5: { component: TreemapComponent, label: "Treemap", icon: Group28, iconSelected: Group28x, options: { spacing: 20 } },
    20: { component: GeoMapComponent, label: "Mapa", icon: Group44, iconSelected: Group44x },
  },

  // ─────────────────────────────────────
  // Group 7 — TABLE
  // ─────────────────────────────────────
  {
    21: { component: TableComponent, label: "Tabela", icon: Group43, iconSelected: Group43x },
  },

  // ─────────────────────────────────────
  // Group 8 — TEXT / IMAGE
  // ─────────────────────────────────────
  {
    100: { component: Titulo, label: "Título" },
    101: { component: Paragrafo, label: "Parágrafo" },
    102: { component: Imagem, label: "Imagem" },
    103: { component: Subtitulo , label: "Subtitulo" },
    104: { component: WidgetPlaceholder , label: "WidgetPlaceholder" },

  },
  // ─────────────────────────────────────
  // Group 9
  // ─────────────────────────────────────
  {
    21: { component: TableComponent, label: "Tabela", icon: dash1, iconSelected: dash1 },
  },
  // ─────────────────────────────────────
  // Group 10
  // ─────────────────────────────────────
  {
    21: { component: TableComponent, label: "Tabela", icon: dash2, iconSelected: dash2 },
  },
  // ─────────────────────────────────────
  // Group 11
  // ─────────────────────────────────────
  {
    21: { component: TableComponent, label: "Tabela", icon: dash3, iconSelected: dash3 },
  },
  // ─────────────────────────────────────
  // Group 12
  // ─────────────────────────────────────
  {
    21: { component: TableComponent, label: "Tabela", icon: dash4, iconSelected: dash4 },
  },
];




// Step 2: Merge all chart groups into one object
export const chartComponentsObj = Object.assign({}, ...chartGroups.slice(1));

const processJsonData = (jsonData, allSheetData) => {
    for (const key in jsonData) {
        if (jsonData.hasOwnProperty(key)) {
            const item = jsonData[key];
            const sheetName = item.IndicadorDsg || 'tabela'; // Use 'table' if IndicadorDsg doesn't exist

            if (!allSheetData[sheetName]) {
                allSheetData[sheetName] = [];
            }

            // Find the correct data property automatically
            const dataProperty = Object.keys(item).find(prop =>
                item[prop] && typeof item[prop] === 'object');

            if (dataProperty) {
                Object.keys(item[dataProperty]).forEach(year => {
                    const sheetData = item[dataProperty][year];
                    const keys = Object.keys(sheetData[0]);
      //const transformedData = sheetData.map(entry => [year, ...keys.map(key => entry[key])]);

                    const transformedData = sheetData.map(entry => {
                        // Check if "dim_3" is "T", skip the entry if true
                        if (entry.dim_3 === "T") {
                            return null; // Skip this entry
                        }
                        return [year, ...keys.map(key => entry[key])];
                    }).filter(Boolean); // Filter out null entries

                    if (allSheetData[sheetName].length === 0) {
                        transformedData.unshift(['Year', ...keys]); // Add headers only once
                    }

                    allSheetData[sheetName].push(...transformedData);
                });
            }
        }
    }
};

export const handleUrl = (data, allFilesData) => {
    let allSheetData = {};

    try {
        const jsonData = data;
        processJsonData(jsonData, allSheetData);
    } catch (error) {
        console.error('Error parsing JSON file:', error);
    }

    // Combine all sheets into a single array
    const combinedSheetData = Object.keys(allSheetData).map(sheetName => ({
        sheetName,
        data: allSheetData[sheetName]
    }));

    allFilesData.push(...combinedSheetData);

    return allFilesData;
};

export const handleFile = (file, data, allFilesData, files_number, setFilesSelected, setHealthData) => {
    let allSheetData = {};

    if (file.name.toLowerCase().endsWith('.json')) {
        try {
            const jsonData = JSON.parse(decodeURIComponent(escape(data)));
            processJsonData(jsonData, allSheetData);
        } catch (error) {
            console.error('Error parsing JSON file:', error);
        }
    } else if (file.name.toLowerCase().endsWith('.xml')) {
  try {

    console.log(data); // log first 500 chars
    const jsonLikeData = xmlIndicadoresToJson(data.replace(/&(?!amp;|lt;|gt;|quot;|apos;)/g, '&amp;'));
    // 3️⃣ Reuse existing JSON processing
    processJsonData(jsonLikeData, allSheetData);

  } catch (error) {
    console.error('Error parsing XML file:', error);
  }

} else {
        // Parse the XLSX data using xlsx library
        const workbook = XLSX.read(data, { type: 'binary', cellText: false, cellDates: true, raw: true });

        workbook.SheetNames.forEach(sheetName => {
            const worksheet = workbook.Sheets[sheetName];

            // Convert worksheet to JSON but manually handle cell values to ensure no type conversion
            let jsonData = XLSX.utils.sheet_to_json(worksheet, {
    header: 1, // Read data as a 2D array
    raw: true, // Keep raw data without parsing
});

// Determine the max number of columns (usually the header length)
const maxCols = jsonData[0]?.length || 0;

// Normalize rows in-place and keep as jsonData
jsonData = jsonData.map((row, rowIndex) =>
    Array.from({ length: maxCols }, (_, colIndex) => {
        let cell = row[colIndex];
        if (cell === undefined || cell === null) {
            console.log(`Row ${rowIndex}, Col ${colIndex} is empty/null`);
            return ''; // convert empty cells to empty string
        }
        return cell.toString(); // convert everything else to string
    })
);


            console.log(jsonData);

            if (file.name.toLowerCase().endsWith('.csv')) {

                const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
                allSheetData[fileNameWithoutExtension] = jsonData;
            } else {
                allSheetData[sheetName] = jsonData;
            }
        });
    }

    // Combine all sheets into a single array
    const combinedSheetData = Object.keys(allSheetData).map(sheetName => ({
        sheetName,
        data: allSheetData[sheetName]
    }));

    allFilesData.push(...combinedSheetData); // Add data of this file to all files' data array

    setHealthData(allFilesData.flat()); // Flatten the array and set data
    setFilesSelected(true); // Files are selected, set to true

};

function xmlIndicadoresToJson(xmlText) {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlText, 'application/xml');

  const parseError = xmlDoc.getElementsByTagName('parsererror');
  if (parseError.length > 0) {
    throw new Error('Invalid XML detected');
  }

  const indicadores = Array.from(xmlDoc.getElementsByTagName('Indicador'));

  const result = indicadores.map(ind => {
    const sheetName = ind.getElementsByTagName('IndicadorDsg')[0]?.textContent || 'tabela';
    const dadosNode = ind.getElementsByTagName('Dados')[0];

    const Dadosrtgrth = {};

    if (dadosNode) {
      Array.from(dadosNode.children).forEach(yearNode => {
        const year = yearNode.tagName.replace('Ano_', '');
        Dadosrtgrth[year] = [];

        Array.from(yearNode.getElementsByTagName('Item')).forEach(itemNode => {
          const item = {};
          Array.from(itemNode.children).forEach(cell => {
            item[cell.tagName] = cell.textContent;
          });
          Dadosrtgrth[year].push(item);
        });
      });
    }

    return { IndicadorDsg: sheetName, Dadosrtgrth };
  });

  return result;
}






export const List = ({ title, data, selectedData, setSelectedData, valueType, valueType2, placeholder, setSelectedColumn, setSelectedDatasets }) => {

  const options = Object.values(data).map(item => ({
    value: item[valueType],
    label: item[valueType2]
  }));


  const handleChange = selectedOption => {
    setSelectedColumn?.('');
    setSelectedDatasets?.('');

    setSelectedData(selectedOption ? String(selectedOption.value) : '');
  };

  const selectedOption = options.find(option => String(option.value).trim() === selectedData);

  return (
    <div className="dropdown-container">
      <label className="project-name-label">{title}</label>
      <Select
        value={selectedOption || null}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        className="dropdown-select"
      />
    </div>
  );
};

export const MultiSelectDropdown = ({ title, data, selectedData, setSelectedData, valueType, valueType2, placeholder }) => {
  const options = data.map(item => ({
    value: item[valueType],
    label: item[valueType2]
  }));

  const handleChange = selectedOptions => {
    setSelectedData(selectedOptions ? selectedOptions.map(option => String(option.value)) : []);
  };

  const selectedOptions = options.filter(option => selectedData.includes(String(option.value)));

  return (
    <div className="dropdown-container">
      <label className="project-name-label">{title}</label>
      <Select
        isMulti
        value={selectedOptions}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        className="dropdown-select"
      />
    </div>
  );
};

export const DatasetSelector = ({ tableColumnData, columns, selectedDatasets, setSelectedDatasets, selectedColumn, setSelectedColumn }) => {

  // check if column is a date column
const isDateColumn = (columnData) => {
  if (!columnData || columnData.length === 0) return false;

  const isValidISODate = (value) =>
    /^\d{4}-\d{2}-\d{2}$/.test(value) && !isNaN(new Date(value).getTime());

  const isValidEuropeanDate = (value) => {
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) return false;
    const [day, month, year] = value.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    return (
      !isNaN(date.getTime()) &&
      date.getDate() === day &&
      date.getMonth() + 1 === month &&
      date.getFullYear() === year
    );
  };

  return columnData.every(value => {
    if (value === null || value === '') return true;
    const trimmed = String(value).trim();
    return isValidISODate(trimmed) || isValidEuropeanDate(trimmed);
  });
};


  // Function to check if a column is valid for datasets (numeric or date)
  const isColumnValidForDataset = (columnData) => {
    if (!columnData || columnData.length === 0) return false;

    const isValidNumber = (value) => !isNaN(Number(value));

    const isValidISODate = (value) => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
      const date = new Date(value);
      return !isNaN(date.getTime());
    };

    const isValidEuropeanDate = (value) => {
  // D/M/YYYY or DD/MM/YYYY
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) return false;

  const [day, month, year] = value.split('/').map(Number);
  const date = new Date(year, month - 1, day);
  return !isNaN(date.getTime()) && date.getDate() === day && (date.getMonth() + 1) === month && date.getFullYear() === year;
};


    const isValidValue = (value) => {
      if (value === null || value === '') return true; // allow empty
      const trimmed = String(value).trim();
      return isValidNumber(trimmed) || isValidISODate(trimmed) || isValidEuropeanDate(trimmed);
    };

    return columnData.every(isValidValue);
  };

  // Filter columns: keep only numeric or valid date columns for datasets
  const validColumns = columns.filter(column =>
    isColumnValidForDataset(tableColumnData?.[column.column_id]?.data)
  );

  // if any selected dataset is a date column → show all columns
const hasSelectedDate = Array.isArray(selectedDatasets) &&
  selectedDatasets.some(columnId =>
    isDateColumn(tableColumnData?.[columnId]?.data)
  );


  const datasetColumns = hasSelectedDate ? columns : validColumns;

  return (
<>
    <List
            title="Dimensão"
            data={columns}
            selectedData={selectedColumn}
            setSelectedData={setSelectedColumn}
            valueType="column_id"
            valueType2="column_name"
            placeholder="Selecionar a variável que organiza os dados"
          />

<MultiSelectDropdown
        title="Valores"
        data={datasetColumns}
        selectedData={selectedDatasets}
        setSelectedData={setSelectedDatasets}
        valueType="column_id"
        valueType2="column_name"
        placeholder="Selecione uma ou mais variáveis numéricas"
      />
    </>
  );
};

const LeftSection = ({ title, topics }) => {
  return (
    <div className="left-section">
      <h2 className="title">{title}</h2>
      <ul className="topics">
        {topics.map((topic, index) => (
          <li key={index}>{topic}</li>
        ))}
      </ul>
    </div>
  );
};

export const ChartSelector = ({
  title,
  topics,
  selectedDatasets,
  tableColumnData,
  setGraphType,
  graphType,
  chartGroup,
}) => {
  const inferBestGraphType = () => {
    if (selectedDatasets.length === 0) return [];

    const recommended = ["1", "2", "17", "18"];

    if (selectedDatasets.length === 1) {
  recommended.push("25", "125", "126");
}
    if (selectedDatasets.length === 2) recommended.push("26");

    const numPoints = selectedDatasets.reduce(
      (sum, id) => sum + tableColumnData[id].data.length,
      0
    );

    const avg = numPoints / selectedDatasets.length;

    if (avg < 11) {
      recommended.push("3", "4", "5", "21");

      if (selectedDatasets.length > 1) {
        recommended.push("12", "13", "14", "15", "19");
      } else {
        recommended.push("6", "7");
      }
    }

    return recommended;
  };

  const chartComponents = chartGroups[chartGroup];
  if (!chartComponents) return null;

  // <-- only render if 2 or more chart types
  if (Object.keys(chartComponents).length < 2)
    return <div style={{ height: "36px" }}></div>;

  const recommendedKeys = inferBestGraphType();

  return (
    <div>
      <h4 className="chart-title">Outras formas de visualização</h4>
      <div className="type-grid">
        {Object.entries(chartComponents).map(
  ([key, { icon, iconSelected, label }]) => {
    const isSelected = String(graphType) === String(key);
    const isRecommended = recommendedKeys.includes(String(key));

    const IconComponent = isSelected && iconSelected
      ? iconSelected
      : icon;

    return (
      <div key={key} className="tooltip-wrapper">
        <button
          type="button"
          className={`
            graphic-type-icon-button
            ${isSelected ? "selected" : ""}
            ${isRecommended ? "recommended" : ""}
          `}
          onClick={() => setGraphType(key)}
        >
          {IconComponent && React.createElement(IconComponent)}
        </button>

        <div className="custom-tooltip">
          {label}
        </div>
      </div>
    );
  }
)}

      </div>
    </div>
  );
};




export const Pagination = ({ currentPage, setCurrentPage, itemsPerPage, DataArray }) => {
  const indexOfLastItem = currentPage * itemsPerPage;

  return (
    DataArray.length > itemsPerPage && (
      <div className="pagination-buttons">
        <button
          className="previous-button"
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <LeftIcon className="icon" />
          <span className="text">Anterior</span>
        </button>
        {renderPageNumbers({ currentPage , setCurrentPage, DataArray, itemsPerPage})}
        <button
          className="next-button"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={indexOfLastItem >= DataArray.length }
        >
          <span className="text">Seguinte</span>
          <RightIcon className="icon" />
        </button>
      </div>
    )
  );
};

export const renderPageNumbers = ({ currentPage , setCurrentPage, DataArray, itemsPerPage}) => {
  const pageNumbers = [];
  const maxPagesToShow = 5; // Change this value to show more or fewer pages
  const totalPages = Math.ceil(DataArray.length / itemsPerPage);

  // Add the first page
  pageNumbers.push(
    <button
      key={1}
      onClick={() => setCurrentPage(1)}
      className={`page-number ${currentPage === 1 ? 'active' : ''}`}
    >
      1
    </button>
  );

  // Add ellipses if necessary
  if (currentPage > maxPagesToShow) {
    pageNumbers.push(<span key="start-ellipsis" className="ellipsis">...</span>);
  }

  // Calculate the start and end page numbers
  const startPage = Math.max(2, currentPage - 2);
  const endPage = Math.min(totalPages - 1, currentPage + 2);

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(
      <button
        key={i}
        onClick={() => setCurrentPage(i)}
        className={`page-number ${currentPage === i ? 'active' : ''}`}
      >
        {i}
      </button>
    );
  }

  // Add ellipses if necessary
  if (currentPage + 2 < totalPages - 1) {
    pageNumbers.push(<span key="end-ellipsis" className="ellipsis">...</span>);
  }

  // Add the last page
  if (totalPages > 1) {
    pageNumbers.push(
      <button
        key={totalPages}
        onClick={() => setCurrentPage(totalPages)}
        className={`page-number ${currentPage === totalPages ? 'active' : ''}`}
      >
        {totalPages}
      </button>
    );
  }

  return (
    <div style={{ maxWidth: '350px' }}>
      {pageNumbers}
    </div>
  );
};

export const ItemList = ({
  tipo,
  isLoaded,
  onView,
  onEdit,
  onDelete,
  onDuplicate,
  onExport,
  onShare,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  DataArray
}) => {

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  function convertToArray(data) {
    if (Array.isArray(data)) {
      return data;
    } else if (data !== null && typeof data === 'object') {
      return Object.entries(DataArray).map(([id, item]) => ({ ...item, [`${tipo}Id`]: id }));
    } else {
      return [];
    }
  }

  let newArray = convertToArray(DataArray);

  useEffect(() => {
  const maxPage = Math.ceil(newArray.length / itemsPerPage) || 1;
  if (currentPage > maxPage) {
    setCurrentPage(maxPage);
  }
}, [newArray.length, itemsPerPage, currentPage, setCurrentPage]);

  let currentData = newArray.slice(indexOfFirstItem, indexOfLastItem);

  const idMap = {
    widget: 'widgetId',
    table: 'table_id',
    dashboard: 'dashboardId',
    project: 'database_id'
  };

  const nameMap = {
    widget: 'name',
    table: 'table_name',
    dashboard: 'name',
    project: 'database_name'
  };

  let items = currentData.map(item => ({
    id: item[idMap[tipo]],
    name: item[nameMap[tipo]],
    isRealTime: item.type === 'real-time',
    isShared: item.isShared === 1 || item.isShared === 2,
    isOwnedAndShared: item.isShared === 2,
    permission: item.permission
  }));

  if (!isLoaded) return null;

  if (newArray.length === 0) {
    return (
      <div className="frame-container">
        <div className="no-items-container">
          {tipo === 'table' && <><DadosBigIcon /><span>Sem dados disponíveis</span></>}
          {tipo === 'widget' && <><WidgetsBigIcon /><span>Sem widgets disponíveis</span></>}
          {tipo === 'project' && <><ProjetosBigIcon /><span>Sem projetos disponíveis</span></>}
          {tipo === 'dashboard' && <><DashboardsBigIcon /><span>Sem dashboards disponíveis</span></>}
        </div>
      </div>
    );
  }

  return (
    <>
      <ul>
        {items.map((item) => (
          <li key={item.id}>
            <div className="project-info">
              <span>
                {item.name}{' '}
                {item.isRealTime && (
                  <span style={{ color: '#d9534f', fontSize: '0.9em', marginLeft: '5px', fontWeight: 'bold' }}>
                    [Tempo-Real]
                  </span>
                )}
                {item.isOwnedAndShared && (
                  <span style={{ color: '#28a745', fontSize: '0.9em', marginLeft: '5px', fontWeight: 'bold' }}>
                    [Partilhado por Mim]
                  </span>
                )}
                {item.isShared && !item.isOwnedAndShared && (
                  <span style={{ color: '#007bff', fontSize: '0.9em', marginLeft: '5px', fontWeight: 'bold' }}>
                    [Partilhado Comigo]
                    {item.permission && (
                      <span style={{ color: '#6c757d', fontSize: '0.9em', marginLeft: '5px', fontWeight: 'normal' }}>
                        ({item.permission === 'read-only' ? 'Leitura' : 'Edição'})
                      </span>
                    )}
                  </span>
                )}
              </span>

              <div className="icons-container">
                {onView && (
                  <div className="tooltip" data-tooltip="Visualizar">
                    <EyeIcon onClick={() => onView(item.id)} style={{ cursor: 'pointer' }} />
                  </div>
                )}

                <div className="tooltip" data-tooltip="Editar">
                  <PenIcon
                    onClick={() => {
                      if ((tipo !== 'widget') || item.permission !== 'read-only') onEdit(item.id);
                    }}
                    style={{
                      cursor: (tipo === 'widget') && item.permission === 'read-only' ? 'not-allowed' : 'pointer',
                      opacity: (tipo === 'widget') && item.permission === 'read-only' ? 0.5 : 1
                    }}
                    disabled={(tipo === 'widget') && item.permission === 'read-only'}
                  />
                </div>

                {onDuplicate && (
                  <div className="tooltip" data-tooltip="Duplicar">
                    <CopyIcon
                      onClick={() => {
                        if ((tipo !== 'table' && tipo !== 'widget' && tipo !== 'dashboard') || item.permission !== 'read-only') {
                          onDuplicate(item.id);
                        }
                      }}
                      style={{
                        cursor: (tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only' ? 'not-allowed' : 'pointer',
                        opacity: (tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only' ? 0.5 : 1
                      }}
                      disabled={(tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only'}
                    />
                  </div>
                )}

                <div className="tooltip" data-tooltip="Eliminar">
                  <TrashIcon
                    onClick={() => {
                      if ((tipo !== 'table' && tipo !== 'widget' && tipo !== 'dashboard') || item.permission !== 'read-only') onDelete(item.id);
                    }}
                    style={{
                      cursor: (tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only' ? 'not-allowed' : 'pointer',
                      opacity: (tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only' ? 0.5 : 1
                    }}
                    disabled={(tipo === 'table' || tipo === 'widget' || tipo === 'dashboard') && item.permission === 'read-only'}
                  />
                </div>

                {onExport && (
                  <div className="tooltip" data-tooltip="Exportar">
                    <ExportIcon onClick={() => onExport(item.id)} style={{ cursor: 'pointer' }} />
                  </div>
                )}

                {onShare && (
                  <div className="tooltip" data-tooltip="Partilhar">
                    <ShareIcon
                      onClick={() => {
                        if (!item.isShared || item.isOwnedAndShared) onShare(item.id);
                      }}
                      style={{
                        cursor: item.isShared && !item.isOwnedAndShared ? 'not-allowed' : 'pointer',
                        opacity: item.isShared && !item.isOwnedAndShared ? 0.5 : 1
                      }}
                      disabled={item.isShared && !item.isOwnedAndShared}
                    />
                  </div>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>

      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        DataArray={newArray}
        itemsPerPage={itemsPerPage}
      />
    </>
  );
};

//Delete success **************************************************************

export function renderModal(isOpen, message, onClose, color, iconID) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <span className="close" onClick={onClose}>&times;</span>

        {iconID === 1 ? (
          <HappyIcon />
        ) : iconID === 2 ? (
          <SadIcon />
        ) : iconID === 3 ? (
          <SaveIcon />
        ) : color === '#E5004E' ? (
          <TrashIcon className="trash-icon-pink" />
        ) : color === '#233A80' ? (
          <ExportIcon className="export-icon-gray" />
        ) : (
          <CopyIcon />
        )}

        <p style={{ color }}>{message}</p>
      </div>
    </div>
  );
}


export function closeModal(setIsOpen) {
  return () => {
    setIsOpen(false);
  };
}

//Are you sure you want delete ******************************************

export const renderConfirmationModal = (isOpen, message, onConfirm, onCancel) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={onCancel} // click outside closes
    >
      <div
        className="ConfirmationModal"
        onClick={(e) => e.stopPropagation()} // clicks inside do NOT close
      >
        <TrashIcon />
        <p>{message}</p>
        <div className="ButtonContainer">
          <button onClick={onConfirm}>Sim</button>
          <button onClick={onCancel}>Não</button>
        </div>
      </div>
    </div>
  );
};

export const renderAutoSaveModal = (isOpen, title, message, onConfirm, onCancel) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={onCancel} // click outside closes
    >
      <div
        className="AutoSaveModal"
        onClick={(e) => e.stopPropagation()} // clicks inside do NOT close
      >
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="ButtonContainer">
          <button onClick={onConfirm}>Fechar e não mostrar de novo</button>
          <button onClick={onCancel}>Fechar</button>
        </div>
      </div>
    </div>
  );
};

export const handleDelete = async (resourceType, projectId, resourceId, token, setResource, allResources, setModalMessage, setModalMessageColor, setIsModalOpen, currentPage, setCurrentPage, itemsPerPage) => {

  const url = projectId ? `${API_BASE_URL}/${resourceType}/${projectId}/${resourceId}` :
  `${API_BASE_URL}/${resourceType}/${resourceId}`;


  try {
    await axios.delete(url, {
      headers: {
        Authorization: `Bearer ${token}` // Include JWT token in Authorization header
      }
    });


    const updatedResources = { ...allResources };
    delete updatedResources[resourceId];
    setResource(updatedResources);

    let message = `${resourceType === 'widgets' ? 'Widget eliminado!' : 'Dados eliminados!'}`;


    setModalMessage(message);
    setModalMessageColor('#E5004E');
    setIsModalOpen(true);

    const newNumPages = Math.ceil((Object.keys(updatedResources).length) / itemsPerPage);

    // If the current page is greater than the new number of pages after deletion,
    // set the current page to the last page
    if (currentPage > newNumPages) {
      setCurrentPage(newNumPages);
    }

  } catch (error) {
    console.error(`Ocorreu um problema ao eliminar o${resourceType === 'widgets' ? ' widget' : 's dados'}... `, error);
  }
};

export const handleDuplicate = async (
  type, id, setData, data,
  successMessage, setIsDuplicating,
  setModalMessage, setModalMessageColor, setIsModalOpen,
  setWidgets, widgets
) => {
  try {
    setIsDuplicating(true);
    const token = localStorage.getItem('token');
    const response = await axios.post(`${API_BASE_URL}/duplicate-${type}/${id}`, null, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const duplicatedItem = response.data[`duplicated${type.charAt(0).toUpperCase() + type.slice(1)}`];

    if (type === 'project') {
      setData([...data, duplicatedItem]);
    } else if (type === 'dashboard') {
      setData({ ...data, ...duplicatedItem });

      if (response.data.newWidgets) {
        setWidgets({ ...widgets, ...response.data.newWidgets });
      }
    } else if (type === 'widget' || type === 'table') {
      setData({ ...data, ...duplicatedItem });
    }

    setIsDuplicating(false);
    setModalMessage(successMessage);
    setModalMessageColor('');
    setIsModalOpen(true);
  } catch (error) {
    console.error(`Error duplicating ${type}:`, error);
    setIsDuplicating(false);
  }
};


export const fetchData = async (url, setData, setIsLoaded, dataKey, sharecode, dashboardId ) => {
  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'dashboardid': dashboardId,
        'sharecode': sharecode,

      }
    });
    setData(response.data[dataKey]);

    setIsLoaded(true);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

export const makePostRequest = async (url, data) => {
  try {
    const response = await axios.post(url, data, { headers: {
  Authorization: `Bearer ${localStorage.getItem('token')}`
} });
    console.log('Request successful:', response);
    return response; // Return response data for further use if needed
  } catch (error) {
    console.error('Error making POST request:', error);
    throw error; // Re-throw the error for further handling if needed
  }
};

export const LoadingOverlay = ({ isDuplicating, spinnerMessage }) => {
  const loadingMessage = spinnerMessage || 'A Duplicar...';

  return (
    isDuplicating && (
      <div className="loading-overlay">
        <div className="loading-spinner"></div>
        <div className="loading-message">{loadingMessage}</div>
      </div>
    )
  );
};

 export const fetchJsonFromUrl = async (url) => {
    try {
      //const response = await axios.get(url);
      const response = await axios.get(`${API_BASE_URL}/proxy?url=${encodeURIComponent(url)}`);

      let allFilesData = [];

      return handleUrl(response.data, allFilesData);
    } catch (error) {
      console.error('Error fetching JSON from URL:', error);
      return null;
    }
  };

  function transformDataWithDeterministicColors(data, seed) {
  // Map each label to a color based on seed + index

  // Apply the same colors to all datasets
  return {
    ...data,
    datasets: data.datasets.map((dataset) => ({
      ...dataset,
      backgroundColor: data.labels.map((_, index) => getDeterministicColor(seed, index)),
      borderColor: data.labels.map((_, index) => getDeterministicColor(seed, index)),
    }))
  };
}


  function transformDataForBubbleChart(inputData, seed) {
    const { labels, datasets } = inputData;

    // Check if labels exist
    if (!labels || labels.length === 0) {
        throw new Error("Input data must contain labels.");
    }

    const bubbleData = {
        labels, // Preserve labels if needed
        datasets: [], // This will hold the bubble data points
    };

    // Step 1: Calculate the maximum data value across all datasets for scaling the bubble size
    let maxDataValue = 0;
    datasets.forEach(dataset => {
        dataset.data.forEach(value => {
            if (value > maxDataValue) {
                maxDataValue = value;
            }
        });
    });

    // Step 2: Create bubble data points for each dataset
    datasets.forEach((dataset, datasetIndex) => {
        const yData = dataset.data; // Y-axis values for this dataset

        const color = getDeterministicColor(seed, datasetIndex);

        // Create a bubble series for the current dataset
        const bubbleSeries = {
            label: dataset.label || `Dataset ${datasetIndex + 1}`, // Use provided label or default
            backgroundColor: dataset.backgroundColor || color,
            borderColor: dataset.borderColor || color,
            borderWidth: 2,
            data: [], // This will hold the bubble data points
        };

        labels.forEach((label, index) => {
            const yValue = yData[index];

            // Ensure valid values before pushing to bubble data
            if (yValue !== undefined) {
                // Step 3: Scale the bubble radius based on the value relative to the maximum data value
                const radius = Math.sqrt(yValue / maxDataValue) * 25; // Scale to a reasonable size

                bubbleSeries.data.push({
                    x: index,           // X-axis value (using index for position)
                    y: yValue,          // Y-axis value
                    r: radius > 0 ? radius : 1, // Ensure radius > 0
                });
            }
        });

        // Add the bubble series to the main bubble data
        bubbleData.datasets.push(bubbleSeries);
    });

    return bubbleData;
}



  export function renderChart(graphType, data, handleClick, Id) {

  const ChartComponent = chartComponentsObj[graphType]?.component;

  const chartData = (graphType === '18' || graphType === '17') //dispersão, bolhas
  ? transformDataForBubbleChart(data,Id)
  : (graphType === '4' || graphType === '3')  //pie, doughnut
  ? transformDataWithDeterministicColors(data,Id)
  : data;

  const customOptions = {
    ...chartComponentsObj[graphType]?.options,
    plugins: {
    ...chartComponentsObj[graphType]?.options?.plugins,
    legend: {
      ...chartComponentsObj[graphType]?.options?.plugins?.legend,
      position: 'bottom',
    },
  },
    elements: {
    ...chartComponentsObj[graphType]?.options?.elements,
  bar: {
      borderRadius: 4,
    },

  point: {
    radius: 4,
    hoverRadius: 6,
  },
  },
    onClick: (e, elements) => {
      if (elements.length > 0 && handleClick) {
        const clickedLabel = chartData.labels[elements[0].index];
        handleClick(clickedLabel); // Trigger the drill-down
      }
    },
  };

  return ChartComponent ? (
    <ChartComponent
      id={Id}
      data={chartData}
      options={customOptions}
    />
  ) : null;
}

function hexToRgba(hex, alpha) {
  const cleanHex = hex.replace("#", "");
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

function getDeterministicColor(seed, datasetIndex = null, totalColors = 100, alpha = 0.8) {

const staticColors = [
  '#F8C92B', // yellow (original)
  '#41BBC9', // cyan / teal (original)
  '#E5074C', // red / pink (original)
  '#243884', // deep blue (original)
  '#2ECC71', // green
  '#9B59B6', // purple
  '#E67E22', // orange
  '#1ABC9C', // bright teal
  '#34495E', // dark slate
  '#D35400'  // burnt orange
];

  const key = (seed === undefined || seed === null) ? '' : String(seed);
  //const key = '' ;

  // Stronger hash for better distribution
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }

  let color;

  if (datasetIndex === null) {
    // Region: pick palette first
    color = staticColors[hash % staticColors.length];
  } else {
    // Dataset: use palette for first 10, else HSL
    const paletteIndex = (hash + datasetIndex) % staticColors.length;
    if (datasetIndex < staticColors.length) {
      color = staticColors[paletteIndex];
    } else {
      const hue = ((hash + datasetIndex * 137) % totalColors) * (360 / totalColors);
      color = `hsl(${hue}, 70%, 50%)`;
    }
  }

  // Convert all colors to transparent
  if (color.startsWith("#")) {
    color = hexToRgba(color, alpha);
  } else if (color.startsWith("hsl")) {
    // convert hsl to hsla
    color = color.replace("hsl", "hsla").replace(")", `, ${alpha})`);
  }

  // Log resulting color
  console.log(`Resulting color → ${color}`);
  return color;
}












export function GraphData(
  labelsColumnId,
  datasetColumnIds,
  tableColumnData,
  conteudo,
  widgetId
) {
  if (conteudo) return conteudo;

  const rawLabels = tableColumnData[labelsColumnId].data;

  // 🔎 Check if ALL datasets are numeric
  const allDatasetsNumeric = datasetColumnIds.every(datasetColumnId =>
    tableColumnData[datasetColumnId].data.some(val =>
      Number.isFinite(Number(val))
    )
  );

  // ===============================
  // ORIGINAL LOGIC (unchanged)
  // ===============================
  if (!allDatasetsNumeric) {
    const uniqueLabels = Array.from(new Set(rawLabels));

    const aggregatedData = datasetColumnIds.map(
      () => new Array(uniqueLabels.length).fill(0)
    );
    const concatenatedData = datasetColumnIds.map(
      () => new Array(uniqueLabels.length).fill('')
    );

    rawLabels.forEach((label, index) => {
      const uniqueIndex = uniqueLabels.indexOf(label);

      datasetColumnIds.forEach((datasetColumnId, datasetIndex) => {
        const currentValue =
          tableColumnData[datasetColumnId].data[index];
        const numericValue = Number(currentValue);

        if (!isNaN(numericValue)) {
          aggregatedData[datasetIndex][uniqueIndex] += numericValue;
        } else {
          concatenatedData[datasetIndex][uniqueIndex] +=
            String(currentValue) + ' ';
        }
      });
    });

    const datasets = datasetColumnIds.map(
      (datasetColumnId, datasetIndex) => {
        const hasNonNumeric = concatenatedData[datasetIndex].some(
          val => val.trim() !== ''
        );

        return {
          label: tableColumnData[datasetColumnId].column_name,
          backgroundColor: getDeterministicColor(widgetId, datasetIndex),
          data: hasNonNumeric
            ? concatenatedData[datasetIndex]
            : aggregatedData[datasetIndex].map(num =>
                num === 0 ? '' : num
              )
        };
      }
    );

    return { labels: uniqueLabels, datasets };
  }

  // ===============================
  // STRICT NUMERIC LOGIC
  // ===============================
  const labels = [];
  const labelIndexMap = new Map();
  const aggregatedData = datasetColumnIds.map(() => []);

  rawLabels.forEach((label, rowIndex) => {
    datasetColumnIds.forEach((datasetColumnId, datasetIndex) => {
      const value =
        tableColumnData[datasetColumnId].data[rowIndex];
      const numericValue = Number(value);

      if (!Number.isFinite(numericValue)) return;

      let index;
      if (labelIndexMap.has(label)) {
        index = labelIndexMap.get(label);
      } else {
        index = labels.length;
        labelIndexMap.set(label, index);
        labels.push(label);
        aggregatedData.forEach(arr => arr.push(0));
      }

      aggregatedData[datasetIndex][index] += numericValue;
    });
  });

  const datasets = datasetColumnIds.map((datasetColumnId, datasetIndex) => ({
    label: tableColumnData[datasetColumnId].column_name,
    backgroundColor: getDeterministicColor(widgetId, datasetIndex),
    borderColor: getDeterministicColor(widgetId, datasetIndex),
    data: aggregatedData[datasetIndex]
  }));

  return { labels, datasets };
}





export const graphicTypeContainersData = [
  {
    title: "Número destaque",
    topics: [
      "Número de itens vendidos",
      "Receita bruta ou líquida",
      "Número de visitantes"
    ],
    chartGroup: 1,
  },

  {
    title: "Comparar valores",
    topics: [
      "Comparação entre categorias",
      "Comparação entre regiões",
      "Rankings e distribuições"
    ],
    chartGroup: 2,
  },

  {
    title: "Mostrar proporções",
    topics: [
      "Participação de mercado",
      "Distribuição percentual",
      "Partes de um todo"
    ],
    chartGroup: 3,
  },

  {
    title: "Evolução no tempo",
    topics: [
      "Tendência de vendas",
      "Crescimento ao longo do tempo",
      "Eventos temporais"
    ],
    chartGroup: 4,
  },

  {
    title: "Relações entre métricas",
    topics: [
      "Correlação entre métricas",
      "Distribuição de dados",
      "Relação entre variáveis"
    ],
    chartGroup: 5,
  },

  {
    title: "Hierarquia e Localização",
    topics: [
      "Estrutura de dados",
      "Distribuição geográfica"
    ],
    chartGroup: 6,
  },

  {
    title: "Tabela de dados",
    topics: [
      "Tabelas"
    ],
    chartGroup: 7,
  },
];



export const ListWithDatasetSelector = ({
  data,
  tableColumnData,
  selectedData,
  setSelectedData,
  isDataLoaded,
  selectedColumn,
  setSelectedColumn,
  selectedDatasets,
  setSelectedDatasets
}) => {
  return (
    <div className="lists-container">
      <List
        title="Tabela"
        data={data}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        valueType="table_id"
        valueType2="table_name"
        placeholder="Selecionar tabela"

        setSelectedColumn={setSelectedColumn}
        setSelectedDatasets={setSelectedDatasets}
      />

      {isDataLoaded && selectedData !== "" && (
        <DatasetSelector
          tableColumnData={tableColumnData}
          columns={data[selectedData]?.columns || []}
          selectedDatasets={selectedDatasets}
          setSelectedDatasets={setSelectedDatasets}
          selectedColumn={selectedColumn}
          setSelectedColumn={setSelectedColumn}
        />
      )}
    </div>
  );
};

export const GraphicTypeContainers = ({
  selectedDatasets,
  tableColumnData,
  setGraphType,
  graphType,
  selectedGroup,
}) => {
  /*
  const allDatasetsAreDates =
    selectedDatasets.length > 0 &&
    selectedDatasets.every(id =>
      tableColumnData[id].data.every(value => {
        const date = new Date(value);
        return !isNaN(date.getTime());
      })
    );*/

  if (!selectedGroup) return null;

  const containerData = graphicTypeContainersData.find(
    g => g.chartGroup === selectedGroup
  );

  if (!containerData) return null;
/*
  if (containerData.hideWhenOnlyDates && !allDatasetsAreDates) {
    return null;
  }*/

  return (
    <ChartSelector
      title={containerData.title}
      topics={containerData.topics}
      selectedDatasets={selectedDatasets}
      tableColumnData={tableColumnData}
      setGraphType={setGraphType}
      graphType={graphType}
      chartGroup={containerData.chartGroup}
    />
  );
};


export const GraphicGroupSelector = ({
  selectedGroup,
  setSelectedGroup,
  setGraphType,
  groups = graphicTypeContainersData,
  chartGroupsSource = chartGroups,
}) => {
  const handleGroupClick = (groupId) => {
    setSelectedGroup(groupId);

    // Auto-select first chart type in this group
    const groupCharts = chartGroupsSource[groupId];
    if (groupCharts) {
      const firstChartType = Object.keys(groupCharts)[0];
      setGraphType(firstChartType);
    }
  };

  return (
    <div className="group-grid">
      {groups.map(group => {
        const groupCharts = chartGroupsSource[group.chartGroup];
        const firstChartKey = groupCharts ? Object.keys(groupCharts)[0] : null;
        let firstChartIcon = firstChartKey ? groupCharts[firstChartKey].icon : null;

        // Exception for a specific group
        if (group.chartGroup === 1) {firstChartIcon = NumberIcon;}

        return (
          <div
            key={group.chartGroup}
            className={`graphic-type-tile ${
              selectedGroup === group.chartGroup ? "selected" : ""
            }`}
            onClick={() => handleGroupClick(group.chartGroup)}
          >
            {/* Tooltip Icon on Top Right */}
            <span
              className="info-icon"
              onClick={(e) => e.stopPropagation()}
            >
              i
              <span className="info-tooltip">
  {group.topics.map((topic, idx) => (
    <div key={idx} className="tooltip-topic">
      • {topic}
    </div>
  ))}
</span>


            </span>

            {/* Render icon if available */}
            {firstChartIcon && (
              <div className="graphic-type-icon">
                {React.createElement(firstChartIcon)}
              </div>
            )}

            {/* Title at the Bottom */}
            <div className="graphic-type-title">
              {group.title}
            </div>
          </div>
        );
      })}
    </div>
  );
};





export const ChartWidget = ({ paletteWidgets, onSelectWidget, tableColumnData, graphType, selectedColumn, selectedDatasets, buttonLabel, onButtonClick, widget, height, tables, Id, disableButton }) => {


  tableColumnData=evaluateData(tableColumnData);

  const getTableIdByColumnId = (columnId) => {
    for (const table of Object.values(tables)) {
        const column = table.columns.find(col => col.column_id === columnId);
        if (column) {
            return table.table_id;
        }
    }
    return null; // Return null if not found
};

  const [drillLevelIndex, setDrillLevelIndex] = useState(0);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [nextColumnId, setNextColumnId] = useState(null);

  const [startColumnId, setStartColumnId] = useState(null);
  let widgetId = 0;

if (!height) {height='600px'}

if (widget) {
    widgetId = Object.keys(widget)[0];
//console.log(Id + "xx: " + JSON.stringify(widgetId));
    graphType = widget[widgetId].graph_type.toString();
    selectedDatasets = widget[widgetId].columns.map(columnId => String(columnId))

selectedColumn = drillLevelIndex === 0
    ? widget[widgetId].label_id.toString() // Start with the widget's initial label
    : (nextColumnId).toString();
}

selectedColumn = drillLevelIndex === 0
    ? selectedColumn // Start with the widget's initial label
    : (nextColumnId).toString();

    const getOrderedColumnIds = () => {

  const tableId = getTableIdByColumnId(parseInt(selectedColumn));
  const columns = tables[tableId].columns;

  return columns
    .sort((a, b) => a.column_order - b.column_order)
    .map(column => column.column_id);
};


    const getNextColumn = (offset) => {
  const orderedColumnIds = getOrderedColumnIds();
  const selectedColumnIndex = orderedColumnIds.indexOf(parseInt(selectedColumn));

  return (selectedColumnIndex !== -1 && selectedColumnIndex + offset < orderedColumnIds.length)
    ? orderedColumnIds[selectedColumnIndex + offset]
    : null;
};

  const handleDrillUp = () => {
      if (drillLevelIndex > 0) {
      const next = getNextColumn(-1);
      setNextColumnId(next);
      setDrillLevelIndex(drillLevelIndex - 1);
      const updatedLabels = [...selectedLabels];
      updatedLabels.pop();
      setSelectedLabels(updatedLabels);
    }
  };

  const handleDrillClick = (clickedLabel) => {
  const next = getNextColumn(1);
  const nextColumnData = next ? tableColumnData[next] : null;



  if (nextColumnData) {

    const isNumericData = nextColumnData.data.every(data =>
      /^[0-9.,]+$/.test(data)  // Allow digits, commas, and periods
    );

    if (!isNumericData) {
      setNextColumnId(next);
      setDrillLevelIndex(drillLevelIndex + 1);
      setSelectedLabels([...selectedLabels, clickedLabel]); // Store the current selection in the drill-down chain
    } else {
      console.log("Drill-down not allowed: the next column contains only numeric data");
    }
  } else {
    console.log("No further drill-down allowed");
  }
};

  let filteredTableColumnData = { ...tableColumnData };

if (selectedLabels){
  if (selectedLabels.length > 0) {



    const selectedColumnIndex = getOrderedColumnIds().indexOf(parseInt(selectedColumn));
    if(!startColumnId) setStartColumnId(selectedColumnIndex);

    // For each drill-down level, filter based on the corresponding selected label
    selectedLabels.forEach((label, level) => {

//console.log("startColumnId" + startColumnId);
      const indice = (startColumnId ?? selectedColumnIndex) + level-1;

      const columnIdForLevel = getOrderedColumnIds()[indice];
      const selectedColumnData = tableColumnData[columnIdForLevel];
      // Get row_ids where the selectedColumn's data matches the label at the current drill level
      const matchingRowIds = selectedColumnData.row_id.filter((rowId, index) => {
        return selectedColumnData.data[index] === selectedLabels[level]; // Match data for the current level
      });

      // Filter each column's data based on these matching row_ids
      for (let columnId in filteredTableColumnData) {
        if ([selectedColumn, ...selectedDatasets].includes(columnId)) {
          const columnData = filteredTableColumnData[columnId];
          filteredTableColumnData[columnId] = {
            ...columnData,
            data: columnData.data.filter((_, index) => matchingRowIds.includes(columnData.row_id[index])),
            row_id: columnData.row_id.filter(rowId => matchingRowIds.includes(rowId)),
          };
        }
      }
    });
  }
}

const content = widget?.widget_id?.conteudo || null;

  return (
  <>
    {graphType && selectedColumn && selectedDatasets.length > 0 ? (
      <>
        <div
          style={{
            position: 'relative', // 🔑 needed for absolute positioning
            height: height,
            width: '100%',
          }}
        >
          {drillLevelIndex > 0 && (
  <button
    onClick={handleDrillUp}
    style={{
      position: 'absolute',
      top: '12px',
      right: '12px',
      zIndex: 20,

      padding: '6px 14px',
      borderRadius: '999px',
      border: '1px solid rgba(255,255,255,0.25)',

      background: 'rgba(55, 65, 81, 0.85)', // slate / graphite
      backdropFilter: 'blur(6px)',

      color: '#F9FAFB',
      fontSize: '13px',
      fontWeight: 500,
      letterSpacing: '0.2px',

      cursor: 'pointer',
      boxShadow:
        '0 4px 10px rgba(0, 0, 0, 0.18), inset 0 1px 0 rgba(255,255,255,0.12)',

      transition: 'all 0.2s ease',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = 'rgba(31, 41, 55, 0.95)'; // darker slate
      e.currentTarget.style.transform = 'translateY(-1px)';
      e.currentTarget.style.boxShadow =
        '0 6px 14px rgba(0, 0, 0, 0.25)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = 'rgba(55, 65, 81, 0.85)';
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow =
        '0 4px 10px rgba(0, 0, 0, 0.18), inset 0 1px 0 rgba(255,255,255,0.12)';
    }}
    onMouseDown={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow =
        '0 3px 8px rgba(0, 0, 0, 0.28)';
    }}
  >
    ↩ Roll up
  </button>
)}



          {renderChart(
            graphType,
            GraphData(
              selectedColumn,
              selectedDatasets,
              filteredTableColumnData,
              content,
              Id
            ),
            handleDrillClick,
            Id
          )}
        </div>

        {buttonLabel && (
          <button
            className="button"
            onClick={() =>
              onButtonClick(selectedDatasets, selectedColumn, graphType)
            }
            disabled={disableButton}
            style={disableButton ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            {buttonLabel}
          </button>
        )}
      </>
    ) : null}
  </>
);

};

export const evaluateData = (data) => {
    const updatedData = { ...data };

    // Generic function to evaluate formulas
    const evaluateFormula = (formula, index, data) => {
        if (!formula) return "";

        // Replace column references with actual values
        const updatedFormula = formula.replace(/C(\d+)/g, (match, colId) => {
            const colData = data[colId]?.data ?? '';

            return colData[index] || 0; // Return the value for the current row or 0 if undefined
        });

        try {

            // Evaluate the expression safely
            return eval(updatedFormula.replace(/,/g, '.')); // WARNING: Using eval can be dangerous with untrusted input
        } catch (error) {
            console.error("Error evaluating formula:", error);
            return "";
        }
    };

    // Iterate over each column to find formulas
    Object.entries(updatedData).forEach(([colId, colData]) => {
        if (colData.formula) {
            // Populate the data based on the formula for each row
            updatedData[colId].data = colData.data.map((_, index) =>
                evaluateFormula(colData.formula, index, updatedData)
            );
        }
    });

    return updatedData;
};

export const Breadcrumbs = ({ items }) => {
  const previousItem = items.length > 1 ? items[items.length - 2] : null;

  const handleBackClick = () => {
    if (previousItem?.onClick) {
      previousItem.onClick();
    }
  };

  return (
    <nav className="breadcrumbs">
      {previousItem && (
        previousItem.onClick ? (
          <span className="breadcrumb-back" onClick={handleBackClick}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="10.8"
              viewBox="0 0 11 9"
              fill="none"
              className="breadcrumb-arrow"
            >
              <path
                d="M0.197812 3.97052C-0.0658731 4.26337 -0.0658731 4.73897 0.197812 5.03182L3.57298 8.78036C3.83666 9.07321 4.26489 9.07321 4.52857 8.78036C4.79225 8.48751 4.79225 8.01191 4.52857 7.71905L2.30518 5.24971L10.125 5.24971C10.4984 5.24971 10.8 4.91468 10.8 4.5C10.8 4.08532 10.4984 3.75029 10.125 3.75029L2.30518 3.75029L4.52857 1.28094C4.79225 0.98809 4.79225 0.512495 4.52857 0.219641C4.26489 -0.0732139 3.83666 -0.0732139 3.57298 0.21964L0.197812 3.96818V3.97052Z"
                fill="white"
              />
            </svg>
          </span>
        ) : previousItem.path ? (
          <NavLink to={previousItem.path} className="breadcrumb-back">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="10.8"
              viewBox="0 0 11 9"
              fill="none"
              className="breadcrumb-arrow"
            >
              <path
                d="M0.197812 3.97052C-0.0658731 4.26337 -0.0658731 4.73897 0.197812 5.03182L3.57298 8.78036C3.83666 9.07321 4.26489 9.07321 4.52857 8.78036C4.79225 8.48751 4.79225 8.01191 4.52857 7.71905L2.30518 5.24971L10.125 5.24971C10.4984 5.24971 10.8 4.91468 10.8 4.5C10.8 4.08532 10.4984 3.75029 10.125 3.75029L2.30518 3.75029L4.52857 1.28094C4.79225 0.98809 4.79225 0.512495 4.52857 0.219641C4.26489 -0.0732139 3.83666 -0.0732139 3.57298 0.21964L0.197812 3.96818V3.97052Z"
                fill="white"
              />
            </svg>
          </NavLink>
        ) : null
      )}

      {items.map((item, index) => (
        <span key={index} className="breadcrumb-item">
          {item.onClick ? (
            <span className="breadcrumb-link" onClick={item.onClick}>
              {item.label}
            </span>
          ) : item.path ? (
            <NavLink to={item.path} className="breadcrumb-link">
              {item.label}
            </NavLink>
          ) : (
            <span className="breadcrumb-current">{item.label}</span>
          )}

          {index < items.length - 1 && (
            <span className="breadcrumb-separator">|</span>
          )}
        </span>
      ))}
    </nav>
  );
};

export const IconButton = ({ Icon, action, tableId, permission, tooltip }) => {
  const isReadOnly = permission === 'read-only';

  return (
    <div className="tooltip" data-tooltip={tooltip}>
      <Icon
        onClick={() => !isReadOnly && action(tableId)}
        style={{
          cursor: isReadOnly ? 'not-allowed' : 'pointer',
          opacity: isReadOnly ? 0.5 : 1
        }}
        disabled={isReadOnly}
      />
    </div>
  );
};

export const saveWidgetThemeToDatabase = async (
  DashboardId,
  widgetId,
  themeNumber
) => {
  return makePostRequest(`${API_BASE_URL}/update-widget-theme`, {
    DashboardId,
    widgetId,
    themeNumber
  });
};
